import { render } from "./NotificationMessage.vue?vue&type=template&id=654e18b0"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__